import { useEffect, useState } from 'react'
import { SEARCH_DEBOUNCE_MS } from '@/shared/constants/timings'

/**
 * Returns a debounced copy of `value` that only updates after `delay` ms have
 * passed without `value` changing. Useful for search inputs so the input stays
 * responsive while the debounced value drives a query.
 */
export function useDebouncedValue<T>(
  value: T,
  delay: number = SEARCH_DEBOUNCE_MS,
): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debouncedValue
}
